export const BOOKING_TEMPLATE_MODEL = "booking-template";

const bookingTemplateModel = {
  jobTitle: "",
  internalDescription: "",
  externalDescription: "",
  status: "",
  yearsReferencesRequired: "",
  otherRequirements: [],
  complianceRequirements: [],
  publishingScheduleTags: [],
  messageTags: [],
  applicationQuestionTags: [],
  costs: [],
  salaryBandLower: "",
  salaryBandUpper: "",
  contractType: "",
  startDate: "",
  salaryCurrencyCode: "",
  grade: "",
  workingHours: "",
  files: [],
  interviewFormatTemplateTags: [],
  requireCv: false,
  requireExperience: false,
  requireQualifications: false,
  anonymiseApplications: 0,
  templateCosts: {
    jsonApi: "hasMany",
    type: "templateCost"
  },
  client: {
    jsonApi: "hasOne",
    type: "organisations"
  },
  function: {
    jsonApi: "hasOne",
    type: "experience-functions"
  }
};

export default bookingTemplateModel;
